import templates from './templates';
import './index.styl';
import { RegenerationHeaderView } from '../../../../../core/views/components';

/**
 * @desc Regeneration Header View
 */
export default class RegenerationCompsHeaderView extends RegenerationHeaderView {
	get template() {
		let step_number = this.getOption( 'step_number' );

		switch ( step_number ) {
			case 'step1':
				return templates.step1;
			case 'step2':
				return templates.step2;
			case 'step3':
				return templates.step3;
			case 'step4':
				return templates.step4;
			default:
				return templates.step1;
		}
	}
}